import { Users } from '@just-in-types';
import { Reducer } from 'redux';
import { GET_CHECKINS, SET_UPDATING_MODE, WATCH_COUPONS } from '../actions';

export interface IUserTempState {
  checkIns: Users.CheckIn[];
  coupons: Users.Coupon[];
  updating: boolean;
  userId: string;
}

const userTempInitialState: IUserTempState = {
  checkIns: [],
  coupons: [],
  updating: false,
  userId: '',
};

const userTempReducer: Reducer<IUserTempState> = (
  state = userTempInitialState,
  { type, payload },
) => {
  switch (type) {
    case WATCH_COUPONS:
      return { ...state, coupons: payload };
    case GET_CHECKINS:
      return { ...state, checkIns: payload };
    case SET_UPDATING_MODE:
      return { ...state, updating: payload };
    // case SET_USER_ID:
    //   return {...state, userId: payload}
    default:
      return state;
  }
};

export default userTempReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/userTempReducer.ts